import React, { useRef } from "react";
import { useIsVisible } from "../hooks/useIsVisible";

const SlideIn = ({
  className,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useIsVisible(ref);
  return (
    <div
      ref={ref}
      className={`${className || ""} ease-in-out duration-500 ${
        isVisible ? "" : "translate-y-32"
      }`}
      {...rest}
    ></div>
  );
};

export default SlideIn;
